import { render, staticRenderFns } from "./PerformResetPassword.vue?vue&type=template&id=7ac26792&"
import script from "./PerformResetPassword.vue?vue&type=script&lang=ts&"
export * from "./PerformResetPassword.vue?vue&type=script&lang=ts&"
import style0 from "./PerformResetPassword.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports